var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageTitle',{staticClass:"strech",attrs:{"title":_vm.$t('renovar_base.titulo', { temporada: _vm.lista_abonados.nombre })}}),_c('RenovarBase')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }